const CEP_TAGGING_PROPERTIES = [
    'loginStatus',
    'currentPageUrl',
    'pageName',
    'pageType',
    'previousPageName',
    'vertical',
    'mtaArray',
    'renewalArray',
    'errorPageCode',
    'errorPageMessage',
    'selfServeProducts'
];

export default CEP_TAGGING_PROPERTIES;
